import { ref, type Ref } from 'vue';
import { STATIONS } from '@/data/graph';
import type { Station } from '@/types';

/**
 * Logique d'autocomplétion sur la liste de stations.
 *
 * Le composant porte juste l'input et la liste — la logique de matching
 * et l'ouverture/fermeture vivent ici pour pouvoir être ré-utilisées.
 *
 * Matching : `String.includes()` insensible à la casse sur le nom.
 *   Simple et suffisant pour 200 villes ; pour 10k+ on passerait à un trie
 *   ou à Fuse.js.
 */
export function useAutocomplete(maxResults = 8) {
  const query = ref('');
  const matches: Ref<Station[]> = ref([]);
  const open = ref(false);

  function update(value: string): void {
    query.value = value;
    const q = value.toLowerCase().trim();
    if (!q) {
      matches.value = [];
      open.value = false;
      return;
    }
    matches.value = STATIONS.filter((s) =>
      s.name.toLowerCase().includes(q),
    ).slice(0, maxResults);
    open.value = matches.value.length > 0;
  }

  function close(): void {
    open.value = false;
  }

  function reset(): void {
    query.value = '';
    matches.value = [];
    open.value = false;
  }

  return { query, matches, open, update, close, reset };
}
